"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTable = require("@tanstack/react-table");
var _TablePagination = _interopRequireDefault(require("./TablePagination"));
var _Checkbox = _interopRequireDefault(require("../form/Checkbox"));
var _TextInput = _interopRequireDefault(require("../form/TextInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-underscore-dangle */

const CoreTableView = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    data,
    columns,
    grouping,
    className,
    noRowsText,
    showTableHeader,
    showPageInfo,
    selectTable,
    expanderFlare,
    expanderRowColor,
    footerRowColor,
    expanderClassName,
    expanderLess,
    expanderMore,
    expanderCircle,
    hasAggregatedBackgroundColor,
    groupBy,
    groupByMode,
    pivotBy,
    showPagination,
    pageSize: pageSizeArg,
    defaultSorted,
    expandedRow,
    expanded,
    fixedLayout,
    filter,
    updateData,
    removeRow,
    autoResetPageIndex
  } = _ref;
  const [rowSelection, setRowSelection] = (0, _react.useState)({});
  const [sorting, setSorting] = (0, _react.useState)([...defaultSorted]);
  const [filtering, setFiltering] = (0, _react.useState)();

  // const [autoResetPageIndex, skipAutoResetPageIndex] = useSkipper();
  // const [data, setData] = useState([...dataArg]);

  // const updateData = (rowIndex, columnId, value) => {
  //   // Skip page index reset until after next rerender
  //   skipAutoResetPageIndex();
  //   console.log("in updatedata");
  //   console.log({ rowIndex, columnId, value });

  //   if (value !== data[rowIndex][columnId]) {
  //     const tempData = [...data];
  //     tempData[rowIndex][columnId] = value;
  //     setData(tempData);
  //   }
  // };

  // const removeRow = (rowIndex) => {
  //   setData((old) => old.filter((row, index) => index !== rowIndex));
  // };

  // useEffect(() => {
  //   setData(dataArg);
  // }, [dataArg]);

  const renderSubComponent = _ref2 => {
    let {
      row
    } = _ref2;
    return typeof expandedRow === 'function' ? expandedRow(row) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  };
  const getRowCanExpand = row => {
    if (row.getIsGrouped()) {
      return true;
    }
    const cells = row.getAllCells();
    if (cells) {
      return cells.some(cell => cell?.column?.columnDef.expander || typeof cell?.column?.columnDef.expanderRow === 'function');
    }
    return false;
  };
  const tweakedColumns = [...columns];
  if (selectTable) {
    const selectColumn = {
      id: 'select',
      width: 1,
      header: _ref3 => {
        let {
          table
        } = _ref3;
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          pb: 4,
          isPulledLeft: true,
          indeterminate: table.getIsSomeRowsSelected(),
          checked: table.getIsAllRowsSelected(),
          onChange: () => table.toggleAllRowsSelected()
        });
      },
      cell: _ref4 => {
        let {
          row
        } = _ref4;
        return /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          pb: 4,
          isPulledLeft: true,
          indeterminate: row.getIsSomeSelected(),
          checked: row.getIsSelected(),
          disabled: !row.getCanSelect(),
          onChange: row.getToggleSelectedHandler()
        });
      }
    };
    tweakedColumns.unshift(selectColumn);
  }
  const table = (0, _reactTable.useReactTable)({
    data,
    columns: tweakedColumns,
    state: {
      grouping,
      rowSelection,
      sorting,
      globalFilter: filtering
    },
    onGlobalFilterChange: setFiltering,
    autoResetExpanded: false,
    initialState: {
      pagination: {
        pageSize: pageSizeArg || 10
      },
      sortBy: defaultSorted,
      expanded
    },
    meta: {
      updateData,
      removeRow
    },
    getRowCanExpand,
    onSortingChange: setSorting,
    enableRowSelection: selectTable,
    onRowSelectionChange: setRowSelection,
    getExpandedRowModel: (0, _reactTable.getExpandedRowModel)(),
    getGroupedRowModel: (0, _reactTable.getGroupedRowModel)(),
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    getPaginationRowModel: (0, _reactTable.getPaginationRowModel)(),
    getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
    getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
    autoResetPageIndex,
    debugTable: true
  });
  (0, _react.useEffect)(() => {
    if (typeof expanded !== 'undefined') {
      table.toggleAllRowsExpanded(expanded);
    }
  }, [expanded]);

  // Pagination variables
  const totalItems = data.length;
  const page = table.getState().pagination.pageIndex;
  const {
    pageSize
  } = table.getState().pagination;
  const fromItem = page === 0 ? 1 : page * pageSize + 1;
  let toItem = fromItem + pageSize - 1;
  if (toItem > totalItems) toItem = totalItems;
  const selected = Object.keys(rowSelection).length;
  (0, _react.useImperativeHandle)(ref, () => ({
    getSelections: () => {
      const selectedRows = [];
      const {
        rows
      } = table.getPreFilteredRowModel();
      if (rowSelection) {
        const positiveSelections = Object.keys(rowSelection).filter(idx => rowSelection[idx]);
        positiveSelections.forEach(idx => {
          selectedRows.push(rows[idx]);
        });
      }
      return selectedRows;
    }
  }));
  const footerTrClassNames = (0, _classnames.default)({
    [`is-${footerRowColor}`]: footerRowColor
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showPageInfo && /*#__PURE__*/_react.default.createElement("div", {
    className: "table-page-info-count"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text--count is-hidden-print"
  }, `${selectTable && typeof selected !== 'undefined' && selected !== null ? `Selected ${selected ? selected.toString() : ''} | ` : ''}Showing ${totalItems > 0 ? fromItem : 0} - ${(toItem >= 0 ? toItem : totalItems).toString()} of ${totalItems ? totalItems.toString() : '0'}`)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ReactTable is-fullwidth core-table"
  }, filter && /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    name: "globalTableFilter",
    placeholder: "Search",
    onChange: val => setFiltering(val)
  }), /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)('table', {
      'is-fixed': fixedLayout
    }, className)
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: (0, _classnames.default)('std-table-thead', {
      'is-sr-only': !showTableHeader
    })
  }, table.getHeaderGroups().map(headerGroup => /*#__PURE__*/_react.default.createElement("tr", {
    key: headerGroup.id,
    className: "std-table-thead-tr"
  }, headerGroup.headers.map((header, headerIndex) => {
    if (groupBy && header?.column?.columnDef?.accessorKey && groupBy.includes(header.column.columnDef.accessorKey)) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: header.id
      });
    }
    return /*#__PURE__*/_react.default.createElement("th", {
      key: header.id,
      colSpan: header.colSpan,
      className: (0, _classnames.default)('std-table-thead-th', header?.column?.columnDef?.headerClassName, {
        '-cursor-pointer': header.column.getCanSort(),
        [`-sort-${header.column.getIsSorted()}`]: header.column.getIsSorted()
      }),
      onClick: () => {
        if (header.column.getCanSort()) {
          // console.log('click');
          // console.log(header.column);
          // console.log(header.column.getIsSorted());
          header.column.toggleSorting();
        }
      },
      width: header?.column?.columnDef?.width
    }, header.isPlaceholder && /*#__PURE__*/_react.default.createElement(_react.Fragment, null), !header.isPlaceholder && selectTable && headerIndex === 1 && (header?.column?.columnDef?.colHeader === '' || !header?.column?.columnDef?.colHeader) && /*#__PURE__*/_react.default.createElement("strong", null, "Select All"), !header.isPlaceholder && (!selectTable || headerIndex !== 1 || header?.column?.columnDef?.colHeader) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())));
  })))), /*#__PURE__*/_react.default.createElement("tbody", null, table.getRowModel().rows.map(row => {
    const trClassNames = (0, _classnames.default)('std-table-tr', {
      'expander-row-flare': expanderFlare,
      'expander-row': row.getIsGrouped() || getRowCanExpand(row),
      'aggregated-row': row.getIsGrouped(),
      'row-group': row.getIsGrouped(),
      [`is-${expanderRowColor}`]: !row.original.expanderRowColor && expanderRowColor && (row.getIsGrouped() || getRowCanExpand(row)),
      [`is-${row.original.expanderRowColor}`]: !expanderRowColor && row.original.expanderRowColor && (row.getIsGrouped() || getRowCanExpand(row))
    });
    const firstCell = row.getVisibleCells() && row.getVisibleCells().length ? row.getVisibleCells().find(cell => cell.getIsGrouped() || row.getCanExpand() && cell?.column?.columnDef.expander) : null;
    if (firstCell && groupByMode === 'colspan' && row.getCanExpand()) {
      const tdClassNames = (0, _classnames.default)('std-table-td', firstCell?.column?.columnDef?.className, {
        'is-row-bg-color': firstCell.getIsGrouped() && hasAggregatedBackgroundColor,
        'is-placeholder': firstCell.getIsPlaceholder(),
        'grouped-data-cell': groupBy && !row.getCanExpand(),
        'aggregated-cell': firstCell.getIsAggregated(),
        'is-hidden-mobile': firstCell.getIsAggregated() && !firstCell.column.columnDef?.pivot && !firstCell.column.columnDef?.subTotal || !firstCell.getIsGrouped() && firstCell.column.columnDef?.pivot
      });
      const expanderClassNames = (0, _classnames.default)('expander-row is-flex is-align-items-center', {
        'is-justify-content-left': firstCell?.column?.columnDef?.align !== 'right',
        'is-justify-content-right': firstCell?.column?.columnDef?.align === 'right'
      });
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: row.id,
        className: trClassNames
      }, /*#__PURE__*/_react.default.createElement("td", {
        key: firstCell.id,
        className: tdClassNames,
        colSpan: row.getVisibleCells().length - (groupBy ? groupBy.length : 0)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "expander-row-colspan"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: expanderClassNames
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "expander pt-1 is-clickable"
      }, row.getIsExpanded() ? /*#__PURE__*/_react.default.createElement("i", {
        className: `material-icons ${expanderClassName || ''} ${expanderCircle ? 'table-nested--trigger' : ''}`,
        onClick: row.getToggleExpandedHandler()
      }, expanderLess) : /*#__PURE__*/_react.default.createElement("i", {
        className: `material-icons ${expanderClassName || ''} ${expanderCircle ? 'table-nested--trigger' : ''}`,
        onClick: row.getToggleExpandedHandler()
      }, expanderMore)), /*#__PURE__*/_react.default.createElement("div", {
        className: "expander-text pl-2"
      }, (0, _reactTable.flexRender)(firstCell.column.columnDef.cell, firstCell.getContext()))), row.getVisibleCells().map((cell, cellIndex) => {
        if (firstCell.id === cell.id) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
        }
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, cell.getIsAggregated() &&
        /*#__PURE__*/
        // If the cell is aggregated, use the Aggregated
        // renderer for cell
        _react.default.createElement("div", {
          className: "merged-item"
        }, (0, _reactTable.flexRender)(cell.column.columnDef.aggregatedCell ?? cell.column.columnDef.cell, cell.getContext())), !cell.getIsGrouped() && !cell.getIsAggregated() && !cell.getIsPlaceholder() && !cell?.column?.columnDef.expander && /*#__PURE__*/_react.default.createElement("div", {
          className: "merged-item"
        }, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())), cell.getIsPlaceholder() && /*#__PURE__*/_react.default.createElement(_react.Fragment, null));
      }))));
    }
    if (groupByMode !== 'colspan' || !row.getCanExpand()) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", {
        key: row.id,
        className: trClassNames
      }, row.getVisibleCells().map((cell, cellIndex) => {
        const tdClassNames = (0, _classnames.default)('std-table-td', cell?.column?.columnDef?.className, {
          'is-row-bg-color': cell.getIsGrouped() && hasAggregatedBackgroundColor,
          'is-placeholder': cell.getIsPlaceholder(),
          'grouped-data-cell': groupBy && !row.getCanExpand(),
          'aggregated-cell': cell.getIsAggregated(),
          'is-hidden-mobile': cell.getIsAggregated() && !cell.column.columnDef?.pivot && !cell.column.columnDef?.subTotal || !cell.getIsGrouped() && cell.column.columnDef?.pivot
        });
        const expanderClassNames = (0, _classnames.default)('expander-row is-flex is-align-items-center', {
          'is-justify-content-left': cell?.column?.columnDef?.align !== 'right',
          'is-justify-content-right': cell?.column?.columnDef?.align === 'right'
        });
        if (cell.getIsPlaceholder() && groupBy && cell?.column?.columnDef?.accessorKey && groupBy.includes(cell.column.columnDef.accessorKey)) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
        }
        if (groupBy && row.getCanExpand() && cellIndex >= groupBy.length && cellIndex < groupBy.length * 2) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
        }
        return /*#__PURE__*/_react.default.createElement("td", {
          key: cell.id,
          className: tdClassNames,
          width: cell?.column?.columnDef?.width
        }, (cell.getIsGrouped() || row.getCanExpand() && cell?.column?.columnDef.expander) && /*#__PURE__*/_react.default.createElement("div", {
          className: expanderClassNames
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "expander pt-1 is-clickable"
        }, row.getIsExpanded() ? /*#__PURE__*/_react.default.createElement("i", {
          className: `material-icons ${expanderClassName || ''} ${expanderCircle ? 'table-nested--trigger' : ''}`,
          onClick: row.getToggleExpandedHandler()
        }, expanderLess) : /*#__PURE__*/_react.default.createElement("i", {
          className: `material-icons ${expanderClassName || ''} ${expanderCircle ? 'table-nested--trigger' : ''}`,
          onClick: row.getToggleExpandedHandler()
        }, expanderMore)), /*#__PURE__*/_react.default.createElement("div", {
          className: "expander-text pl-2"
        }, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext()))), cell.getIsAggregated() &&
        // If the cell is aggregated, use the Aggregated
        // renderer for cell
        (0, _reactTable.flexRender)(cell.column.columnDef.aggregatedCell ?? cell.column.columnDef.cell, cell.getContext()), !cell.getIsGrouped() && !cell.getIsAggregated() && !cell.getIsPlaceholder() && !cell?.column?.columnDef.expander && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactTable.flexRender)(cell.column.columnDef.cell, cell.getContext())), cell.getIsPlaceholder() && /*#__PURE__*/_react.default.createElement(_react.Fragment, null));
      })), row.getIsExpanded() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderSubComponent({
        row
      })));
    }
  })), data && data.length > 0 && table.getFooterGroups().some(footerGroup => footerGroup.headers.some(header => typeof header.column.columnDef.footer !== 'undefined')) && /*#__PURE__*/_react.default.createElement("tfoot", {
    className: "std-table-tfoot"
  }, table.getFooterGroups().map(footerGroup => {
    let footerGroupByHideCount = 0;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: footerGroup.id,
      className: (0, _classnames.default)('std-table-tfoot-tr', footerTrClassNames)
    }, footerGroup.headers.map(header => {
      if (groupBy && footerGroupByHideCount < groupBy.length && !(header?.column?.columnDef?.footerVal || typeof header?.column?.columnDef?.footerVal === 'boolean')) {
        footerGroupByHideCount++;
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
      }
      return /*#__PURE__*/_react.default.createElement("td", {
        key: header.id,
        colSpan: header.colSpan,
        className: (0, _classnames.default)('std-table-tfoot-td', header?.column?.columnDef?.footerClassName),
        width: header?.column?.columnDef?.width
      }, header.isPlaceholder ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactTable.flexRender)(header.column.columnDef.footer, header.getContext())));
    }));
  })), selectTable && /*#__PURE__*/_react.default.createElement("tfoot", {
    className: "std-table-thead"
  }, /*#__PURE__*/_react.default.createElement("tr", {
    className: "std-table-thead-tr"
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: "std-table-thead-th"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    pb: 4,
    isPulledLeft: true,
    indeterminate: table.getIsSomePageRowsSelected(),
    checked: table.getIsAllPageRowsSelected(),
    onChange: () => table.toggleAllPageRowsSelected()
  })), /*#__PURE__*/_react.default.createElement("td", {
    colSpan: columns.length
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Select Page (", table.getRowModel().rows.length, ")"))))), (!data || data.length === 0) && /*#__PURE__*/_react.default.createElement("div", {
    className: "rt-noData"
  }, noRowsText), showPagination && /*#__PURE__*/_react.default.createElement("div", {
    className: "table-pagination"
  }, /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
    table: table
  }))));
});
CoreTableView.displayName = 'CoreTableView';
CoreTableView.propTypes = {
  columns: _propTypes.default.array,
  data: _propTypes.default.array,
  grouping: _propTypes.default.array,
  loading: _propTypes.default.bool,
  isError: _propTypes.default.bool,
  selectTable: _propTypes.default.bool,
  noRowsText: _propTypes.default.string,
  keyField: _propTypes.default.string,
  onToggle: _propTypes.default.func,
  getTrProps: _propTypes.default.func,
  getTdProps: _propTypes.default.func,
  getTheadTrProps: _propTypes.default.func,
  getTheadThProps: _propTypes.default.func,
  getTfootTrProps: _propTypes.default.func,
  getTfootTdProps: _propTypes.default.func,
  checkWidth: _propTypes.default.bool,
  className: _propTypes.default.string,
  showTableHeader: _propTypes.default.bool,
  showPageInfo: _propTypes.default.bool,
  expanderFlare: _propTypes.default.bool,
  expanderRowColor: _propTypes.default.string,
  footerRowColor: _propTypes.default.string,
  expanderClassName: _propTypes.default.string,
  expanderLess: _propTypes.default.string,
  expanderMore: _propTypes.default.string,
  expanderCircle: _propTypes.default.bool,
  fixedLayout: _propTypes.default.bool,
  hasAggregatedBackgroundColor: _propTypes.default.bool,
  groupBy: _propTypes.default.array,
  pivotBy: _propTypes.default.array,
  groupByMode: _propTypes.default.string,
  showPagination: _propTypes.default.bool,
  pageSize: _propTypes.default.number,
  defaultSorted: _propTypes.default.bool,
  expandedRow: _propTypes.default.func,
  expanded: _propTypes.default.bool,
  filter: _propTypes.default.bool,
  updateData: _propTypes.default.func,
  removeRow: _propTypes.default.func,
  autoResetPageIndex: _propTypes.default.number
};
CoreTableView.defaultProps = {
  loading: false,
  isError: false,
  selectTable: false,
  checkWidth: true,
  noRowsText: 'No rows found',
  keyField: 'id',
  onToggle: () => {},
  className: 'is-fullwidth',
  showTableHeader: true,
  showPageInfo: true
};
var _default = exports.default = CoreTableView;
//# sourceMappingURL=CoreTableView.js.map